import {times} from 'lodash';
import {FC} from 'react';
import {Placeholder} from 'semantic-ui-react';

import {WIDGET_TYPE_STAGE} from '../consts';
import {Widget as WidgetType, WidgetComponentType} from '../types';

import StageWidget from './StageWidget';

import './Widget.less';

export const widgetComponentsByType: Record<WidgetComponentType, typeof StageWidget> = {
  [WIDGET_TYPE_STAGE]: StageWidget,
};

type WidgetProps = {
  widget: WidgetType;
}

const Widget: FC<WidgetProps> = (props) => {
  const {widget} = props;
  const WidgetComponent = widgetComponentsByType[widget.type];

  if (!WidgetComponent) return null;

  return (
    <WidgetComponent
      loaderContent={<WidgetLoader />}
      {...props}
    />
  );
};

export const WidgetLoader: FC = () => (
  <div className='widget-loader'>
    <Placeholder>
      {times(6, (index) => (
        <Placeholder.Line key={index} />
      ))}
    </Placeholder>
  </div>
);

export default Widget;
